import React from 'react';
import { BrowserRouter, Routes, Route, Link, useLocation } from 'react-router-dom';
import { Overview } from './pages/Overview';
import { FeedbackExplorer } from './pages/FeedbackExplorer';
import './index.css';

const Navigation: React.FC = () => {
    const location = useLocation();

    const isActive = (path: string) => location.pathname === path;

    return (
        <nav className="bg-white/80 backdrop-blur-sm border-b border-gray-200 sticky top-0 z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-16">
                    {/* Logo */}
                    <div className="flex items-center gap-2">
                        <div className="text-2xl">📊</div>
                        <h1 className="text-xl font-bold text-gradient">Feedback Hub</h1>
                    </div>

                    {/* Navigation Links */}
                    <div className="flex gap-1">
                        <Link
                            to="/"
                            className={`px-4 py-2 rounded-lg font-medium transition-all ${isActive('/')
                                    ? 'bg-primary-100 text-primary-700'
                                    : 'text-gray-600 hover:bg-gray-100'
                                }`}
                        >
                            Overview
                        </Link>
                        <Link
                            to="/feedback"
                            className={`px-4 py-2 rounded-lg font-medium transition-all ${isActive('/feedback')
                                    ? 'bg-primary-100 text-primary-700'
                                    : 'text-gray-600 hover:bg-gray-100'
                                }`}
                        >
                            Explorer
                        </Link>
                    </div>
                </div>
            </div>
        </nav>
    );
};

const App: React.FC = () => {
    return (
        <BrowserRouter>
            <div className="min-h-screen">
                <Navigation />
                <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                    <Routes>
                        <Route path="/" element={<Overview />} />
                        <Route path="/feedback" element={<FeedbackExplorer />} />
                    </Routes>
                </main>
            </div>
        </BrowserRouter>
    );
};

export default App;
